import { render, staticRenderFns } from "./BaseCardListBlock.vue?vue&type=template&id=62230dc2&scoped=true"
import script from "./BaseCardListBlock.vue?vue&type=script&lang=js"
export * from "./BaseCardListBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseCardListBlock.vue?vue&type=style&index=0&id=62230dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62230dc2",
  null
  
)

export default component.exports